import { render, staticRenderFns } from "./OrganizationDeleted.vue?vue&type=template&id=3b1e4f7c&scoped=true"
import script from "./OrganizationDeleted.vue?vue&type=script&lang=js"
export * from "./OrganizationDeleted.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e4f7c",
  null
  
)

export default component.exports